export default __webpack_public_path__ + "static/media/basket-white.ce71e7b8.svg";